import { DigitalizationCheckBotStatus } from './digitalization-check-bot-status.enum';
import { DigitalizationFormalControlStatus } from './digitalization-formal-control-status.enum';
import { DocumentStatus } from './document-status.type';
import { MetadataInspectionStatus } from './metadata-inspection-status.enum';
import { QualityCheckStatus } from './quality-check-status.enum';

export const WAITING_METADATA_INSPECTION_STATUSES: readonly MetadataInspectionStatus[] =
  [MetadataInspectionStatus.WAITING];

export const POSITIVE_QUALITY_CHECK_STATUSES: readonly QualityCheckStatus[] = [
  QualityCheckStatus.ACCEPTED,
];

export const WAITING_QUALITY_CHECK_STATUSES: readonly QualityCheckStatus[] = [
  QualityCheckStatus.WAITING,
  QualityCheckStatus.WAITING_FOR_FORMAL_CONTROL,
];

export const REJECTED_QUALITY_CHECK_STATUSES: readonly QualityCheckStatus[] = [
  QualityCheckStatus.REJECTED,
];

export const WAITING_DIGITALIZATION_CHECK_BOT_STATUSES: readonly DigitalizationCheckBotStatus[] =
  [
    DigitalizationCheckBotStatus.WAITING_FOR_METADATA_INSPECTION,
    DigitalizationCheckBotStatus.WAITING,
  ];

export const POSITIVE_DIGITALIZATION_FORMAL_CONTROL_STATUSES: readonly DigitalizationFormalControlStatus[] =
  [
    DigitalizationFormalControlStatus.ACCEPTED,
    DigitalizationFormalControlStatus.ACCEPTED_WITH_REMARKS,
  ] as const;

export const FAILED_DIGITALIZATION_FORMAL_CONTROL_STATUSES: readonly DigitalizationFormalControlStatus[] =
  [DigitalizationFormalControlStatus.REJECTED];
